import React from 'react';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../../locale/jsonMessages';
import s from './OwnerReporting.css';

// Loading skeletons (cards + panels + rows), shared by the reporting pages. `label` replaces the default accessible name.
export const LoadingSkeleton = withStyles(s)(({ cards = 3, panels = 2, rows = 5, label }) => {
  const { formatMessage } = useIntl();
  return (
    <div role="status" aria-busy="true" aria-label={label || formatMessage(messages.orpLoading)} data-testid="reporting-skeleton">
      <div className={s.cardGrid}>
        {Array.from({ length: cards }).map((_, index) => <div key={index} className={cx(s.skeleton, s.skeletonCard)} />)}
      </div>
      <div className={s.panelGrid}>
        {Array.from({ length: panels }).map((_, index) => <div key={index} className={cx(s.skeleton, s.skeletonPanel)} />)}
      </div>
      {Array.from({ length: rows }).map((_, index) => <div key={index} className={cx(s.skeleton, s.skeletonRow)} />)}
    </div>
  );
});

// Error with a retry button. `message` is the server message when there is one (already translated), else a generic text ;
// `title` replaces the default heading (each page words its own).
export const ErrorState = withStyles(s)(({ message, title, onRetry }) => {
  const { formatMessage } = useIntl();
  return (
    <div className={cx(s.stateBox, s.stateError)} role="alert">
      <h2 className={s.stateTitle}>{title || formatMessage(messages.orpErrorTitle)}</h2>
      <p className={s.stateText}>{message || formatMessage(messages.orpErrorText)}</p>
      <div className={s.stateActions}>
        <button type="button" className={s.primaryButton} onClick={onRetry}>{formatMessage(messages.orpRetry)}</button>
      </div>
    </div>
  );
});

// Generic message box (empty, no result, not an owner...). actions: React nodes.
export const MessageState = withStyles(s)(({ title, text, children }) => (
  <div className={s.stateBox}>
    <h2 className={s.stateTitle}>{title}</h2>
    {text && <p className={s.stateText}>{text}</p>}
    {children && <div className={s.stateActions}>{children}</div>}
  </div>
));
